module.exports = __webpack_public_path__ + "img/Courier-Bold.35a3519f.svg";